import { gql } from '@apollo/client';

import { GROUP_DETAILS_FRAGMENT } from 'features/groups/queries';

export const USER_JOINED_GROUPS = gql`
  query UserJoinedGroups($user: ID!, $filter: GroupFilter!) {
    joinedGroups: groupsList(
      filter: {
        AND: [
          $filter
          {
            OR: [
              { createdBy: { id: { equals: $user } } }
              # https://github.com/8base-services/jebel/issues/1435
              # https://github.com/jebelapp/jebel/issues/1808#issuecomment-2905334927
              {
                groupToJoin: {
                  some: { status: { equals: "Approved" }, user: { id: { equals: $user } } }
                }
              }
              # https://github.com/8base-services/jebel/issues/1435
              {
                groupAdminPreferences: {
                  some: { status: { equals: "active" }, user: { id: { equals: $user } } }
                }
              }
            ]
          }
        ]
      }
    ) {
      count
      items {
        ...GroupDetails
      }
    }
  }

  ${GROUP_DETAILS_FRAGMENT}
`;

export const GROUP_MEMBER_REQUEST_UPSERT_MUTATION = gql`
  mutation GroupMemberRequestUpsert($groupId: ID!, $userId: ID!, $status: String!) {
    transaction: groupMembersRequestUpsert(groupId: $groupId, userId: $userId, status: $status) {
      successful
      message
    }
  }
`;

export const GROUP_MEMBER_REQUESTS_QUERY = gql`
  query GroupMemberRequests($userId: ID!, $groupId: ID!) {
    requests: groupsMembersRequestsList(
      filter: { user: { id: { equals: $userId } }, group: { id: { equals: $groupId } } }
    ) {
      items {
        id
      }
      count
    }
  }
`;
